import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export const VideoModal = ({ open, onClose, video }) => (
  <AnimatePresence>
    {open && video && (
      <motion.div className="fixed inset-0 z-[110] flex items-center justify-center p-4"
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="video-modal">
        <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} data-testid="video-overlay" />
        <motion.div className="relative z-10 w-full max-w-4xl"
          initial={{ opacity: 0, scale: 0.95, y: 20 }} animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.97 }} transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}>
          <button onClick={onClose} className="absolute -top-11 right-0 text-white/70 hover:text-white transition-colors flex items-center gap-1.5 text-sm" data-testid="video-close">
            <X size={20} /> Close
          </button>
          <div className="relative w-full rounded-2xl overflow-hidden border border-white/10 shadow-2xl" style={{ paddingBottom: "56.25%" }}>
            <iframe
              className="absolute inset-0 w-full h-full"
              src={`https://www.youtube.com/embed/${video.id}?autoplay=1&rel=0`}
              title={video.title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              data-testid="video-iframe"
            />
          </div>
          <p className="mt-4 font-display font-semibold text-white text-lg">{video.title}</p>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
